'use strict'

/**
 *
 * @name: nnBaseImg
 *
 */

import DirectiveTemplate from './nn-base-img.directive.html'
import './nn-base-img.directive.scss'

function NnBaseImgDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      alt: '=*',
      src: '=*',
      aspectRatio: '=*',
      cover: '=*',
      noLazy: '=*'
    },
    template: DirectiveTemplate,
    controller: nnBaseImgDirectiveController
  }
}

function nnBaseImgDirectiveController ($scope) {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */

  $scope.className = () => {
    return {
      'nn-base-img--aspect-ratio': $scope.aspectRatio,
      'nn-base-img--cover': $scope.cover
    }
  }
  $scope.styles = () => {
    return {
      'padding-top': $scope.aspectRatio ? $scope.aspectRatio * 100 + '%' : ''
    }
  }



  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */



}

export default NnBaseImgDirective



// WEBPACK FOOTER //
// ./app/components/nn-base-components/nn-base-img/nn-base-img.directive.js